import axios from "axios";
import router from '../router'

const AuthPlugin = function install(Vue) {
    let storageValue = null;

    try {
        storageValue = JSON.parse(localStorage.getItem('$authenticatedUser'));
    }
    catch (e) {
        console.log(e);
    }

    const authenticationInfo = Vue.observable({ isAuthenticated: storageValue != null, authenticatedUser: storageValue });
	  axios.defaults.headers.common['Authorization'] = `Bearer ${authenticationInfo?.authenticatedUser?.jwt}`;

    Vue.prototype.$loginUser = async function ({ username, password, remember }) {
        const response = await axios
            .post(`${this.$domain}v1/User/authenticate`, { username, password, remember });

        if (response) {
            localStorage.setItem('$authenticatedUser', JSON.stringify(response.data.result));
            authenticationInfo.authenticatedUser = response.data.result;
            authenticationInfo.isAuthenticated = true;
            axios.defaults.headers.common['Authorization'] = `Bearer ${authenticationInfo.authenticatedUser.jwt}`;
            router.replace({ name: this.$landingPage });
            return true;
        }
    } 
    
    Vue.prototype.$resetPassword = async function ({ currentPassword, newPassword }) {
        const response = await axios
            .put(`${this.$domain}v1/User/resetPassword`, { currentPassword, newPassword });

        if (response) {
            return true;
        }
    }

    Vue.prototype.$logoutUser = async function () {
        try {
            await axios.post(`${this.$domain}v1/User/logout`);
        }
        finally {
            authenticationInfo.authenticatedUser = null;
            authenticationInfo.isAuthenticated = false;
            axios.defaults.headers.common['Authorization'] = '';

            localStorage.removeItem('$authenticatedUser');

            if (router.currentRoute.name !== this.$loginPage)
                router.push({ name: this.$loginPage });
        }
    }

    Object.defineProperty(Vue.prototype, '$user', {
        get() {
            authenticationInfo.authenticatedUser = authenticationInfo.authenticatedUser ?? localStorage.getItem('$authenticatedUser');
            return authenticationInfo.authenticatedUser;
        },
    });

    Vue.prototype.$authenticationInfo = authenticationInfo;

    Vue.mixin({
        methods: {}
    });
}

export default AuthPlugin;
